import React from 'react'
import { connect } from 'react-redux'
import moment from 'moment'
import { LKDate } from 'loankeeper-common/helpers/Date'

//@ts-ignore
import LKGrid from 'shared/LKGrid'
import { colors } from 'shared'
//@ts-ignore
import withLivedata from 'shared/containers/withLivedata'

import { getActiveOldGraphicRestrDate } from '../selectors'
import { OldGraphic } from '.'
import { OldGraphicProps } from 'src/features/LoanDetails/types.LoanDetails'

const config = {
  gridIdentity: {
    formName: 'frm_loan_view',
    objectName: 'grd_old_schedule',
  },

  syncGridState: true,
  enableColumnsResize: true,
  enableColumnsOrder: true,
  enableRowSelection: true,

  columnDefs: [
    { headerName: 'OperDate', field: 'OperDate' },
    { headerName: 'Disburse', field: 'Disburse' },
    { headerName: 'ProcFee', field: 'ProcFee' },
    { headerName: 'Principal', field: 'Principal' },
    { headerName: 'Interest', field: 'Interest' },
    { headerName: 'TotalCover', field: 'TotalCover' },
    { headerName: 'OSBalance', field: 'OSBalance' },
  ],

  columnConfigs: {
    OperDate: {
      valueFormatter: ({ value }) => LKDate.from(value).toString(),
    },

    Disburse: {
      valueFormatter: ({ value }) => value.toFixed(2),
      cellStyle: { textAlign: 'right' },
    },

    ProcFee: {
      valueFormatter: ({ value }) => value.toFixed(2),
      cellStyle: { textAlign: 'right' },
    },

    Principal: {
      valueFormatter: ({ value }) => value.toFixed(2),
      cellStyle: { textAlign: 'right' },
    },

    Interest: {
      valueFormatter: ({ value }) => value.toFixed(2),
      cellStyle: { textAlign: 'right' },
    },

    TotalCover: {
      valueFormatter: ({ value }) => value.toFixed(2),
      cellStyle: { textAlign: 'right' },
    },

    OSBalance: {
      valueFormatter: ({ value }) => value.toFixed(2),
      cellStyle: { textAlign: 'right' },
    },
  },

  getContextMenuItems: () => ['excelExport'],
}

@withLivedata('OpenDayStatus.Open_Day as OpenDay')
//@ts-ignore
@connect((state, { ID }) => ({ currentRestrGraphicDate: getActiveOldGraphicRestrDate(state, ID) }))
class OldSchedule extends React.Component<OldGraphicProps> {
  getRowStyle = ({
    node: {
      data: { OperDate },
    },
  }) => {
    const { currentRestrGraphicDate } = this.props

    return {
      color: moment(OperDate).isBefore(currentRestrGraphicDate) ? colors.black : colors.grey,
    }
  }

  render() {
    const { instanceName, data } = this.props

    return (
      <LKGrid instanceName={instanceName} rowData={data} getRowStyle={this.getRowStyle} {...config} loading={!data} />
    )
  }
}

export default OldSchedule
